import { createSelector } from 'reselect';

const products = state => state.modules.storeHome;

export const getProductsStatus = createSelector(
  products,
  state => state.productsStatus
);

export const getProductsData = createSelector(
  products,
  state => state.productsData
);

export const getItemCommentsStatus = createSelector(
  products,
  state => state.itemCommentsStatus
);

export const getItemCommentsData = createSelector(
  products,
  state => state.itemCommentsData
);

export const getCategoryCommentsStatus = createSelector(
  products,
  state => state.categoryCommentsStatus
);

export const getCategoryCommentsData = createSelector(
  products,
  state => state.categoryCommentsData
);

// getIsStockOrder is actually ORDERSTATUS (see contacts.js)
// 
// 
export const getIsStockOrder = createSelector(
  products,
  state => state.isStockOrder
);
